import React from "react";
import { FaMoon, FaSun } from "react-icons/fa";
import { useDarkMode } from "../../contexts/DarkModeContext";

function DarkModeToggle() {
  const { darkMode, toggleDarkMode } = useDarkMode();

  return (
    <button
      onClick={toggleDarkMode}
      className="btn btn-link text-decoration-none"
      style={{ color: "inherit", padding: "0.5rem" }}
      title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
      aria-label={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
    >
      {darkMode ? <FaSun size={20} /> : <FaMoon size={20} />}
    </button>
  );
}

export default DarkModeToggle;
